import { DesignResource } from '@/api/serverApi'
import { DateTimeFormatHelper } from '@cfs-fixings/shared'

type PropTypes = {
  design: DesignResource
  dropdown?: React.ReactNode
}

function DesignGridCard ({ design, dropdown }: PropTypes) {
  return (
    <div
      title={design.name}
      className="flex flex-col p-1.5 hover:bg-gray-50 transition-all rounded relative max-w-[252px]"
    >
      <img
        src={design.thumbnail_url}
        alt=""
        className="min-h-[144px] aspect-video object-cover rounded border border-gray-400"
      />
      <div className="absolute top-[7px] left-[7px]">
        {dropdown}
      </div>
      <p className="text-sm leading-[16.8px] mt-2 truncate">
        {design.name}
      </p>
      <p className="flex items-center text-xs text-gray-600 leading-[16.8px] mt-[3px]">
        {`Edited ${DateTimeFormatHelper.toRelativeTimeAgo(design.updated_at)}`}
      </p>
    </div>
  )
}

export default DesignGridCard
